const baseUrl = process.env.VUE_APP_BASE_URL
const baseUrl2 = process.env.VUE_APP_BASE_URL2

export default {
  apiKey: process.env.VUE_APP_API_KEY,

  // Endpoints
  loginEndpoint: `${baseUrl}/jwt/login`,
  registerEndpoint: `${baseUrl}/jwt/register`,
  refreshEndpoint: `${baseUrl}/jwt/refresh-token`,
  logoutEndpoint: `${baseUrl}/jwt/logout`,

  login: `${baseUrl}/users/login`, // {"phoneNumber":"{{phoneNumber}}","password":"{{loginPass}}"}
  emailLogin: `${baseUrl}/users/email-login`, // {"email":"{{email}}","password":"{{loginPass}}"}
  googleLogin: `${baseUrl}/users/google-login`, // {"accessToken":"{{googleAccessToken}}","userId":"{{googleUserId}}"}
  appleLogin: `${baseUrl}/users/apple-login`, // {"authorizationCode":"{{appleAuthorizationCode}}"}
  register: `${baseUrl}/users`, // {"firstName":"first_name","lastName":"last_name", "gender": "male", "phoneNumber" :"05321111111", "userName" : "user_name", "password":"pass", "email": "email@email.com", "facebook":"1234567", "city":"Adana", "description":"abcdef", "year":"1980", "month":"1", "date":"1", "lookingForGender":"female"}
  settingsRegister: `${baseUrl}/settings/register`, // {"deviceToken":"deviceToken","playerId":"playerId", "deviceId":"deviceId"}
  emailRegister: `${baseUrl}/users/email-register`,
  usernameValidation: `${baseUrl}/users/username/validation`, // {"username" : "user_name"}
  phoneVerification: `${baseUrl}/users/verification/{{phoneNumber}}`,
  phoneCheck: `${baseUrl}/users/phonecheck/{{phoneNumber}}`,
  emailVerification: `${baseUrl}/users/email-verification`,
  generateUsername: `${baseUrl}/users/generate-username`,
  me: `${baseUrl}/users/me`,
  updateMe: `${baseUrl}/users`,
  logout: `${baseUrl}/users/logout`,
  updateProfile: `${baseUrl}/userprofiles`,
  putPendingUser: `${baseUrl}/users/pending-user`,
  nearByRegions: `${baseUrl}/users/list/nearby-regions`,
  usersList: `${baseUrl}/users/list/{{type}}/{{offset}}/{{limit}}`,
  usersCallListPermitted: `${baseUrl}/users/call-list-permitted`,
  usersListAutoComplete: `${baseUrl}/users/list/auto-complete`,
  loggedUsers: `${baseUrl}/users/logged/{{offset}}/{{limit}}`, // {"searchType":"0", "gender":"female", "ageFrom":"30", "ageTo": "50", "city": "Ankara"} {"searchType":"1"} {"searchType":"2"} {"searchType":"3", "randomSearchType":"2"}
  shortUsers: `${baseUrl}/users/short/{{offset}}/{{limit}}`, // {"searchType":"0", "gender":"female", "ageFrom":"30", "ageTo": "50", "city": "Ankara"}
  randomUsers: `${baseUrl}/users/random`,
  getUser: `${baseUrl}/users/{{id}}`,
  getMatchingUsers: `${baseUrl}/users/matching/{{offset}}/{{limit}}`,
  userMergeFacebook: `${baseUrl}/users/merge-facebook`, // {"phoneNumber":"05321111111", "password":"1234", "facebook":"facebookId"}
  requestPassword: `${baseUrl}/users/request-password/{{phoneNumber}}`,
  requestPasswordEmail: `${baseUrl}/users/email-request-pincode`,
  searchUsersByUsername: `${baseUrl}users/search/username/{{offset}}/{{limit}}`, // {"searchType":"0", "gender":"female", "ageFrom":"30", "ageTo": "50", "city": "Ankara"}
  searchUsers: `${baseUrl}/users/search/{{offset}}/{{limit}}`, // {"searchType":"0", "gender":"female", "ageFrom":"30", "ageTo": "50", "city": "Ankara"}
  updateUserPhone: `${baseUrl}/users/phonenumber/{{phoneNumber}}`,
  userInvalidatePhone: `${baseUrl}/users/invalidate/{{phoneNumber}}`,
  updateUser: `${baseUrl}/users`, // {"firstName":"tom", "lastName":"brown", "email":"tom@brown.com"}
  interests: `${baseUrl}/interest/types?lang=tr`,
  myInterests: `${baseUrl}/interest`,
  updateMyInterests: `${baseUrl}/interest`,
  favoriteUsers: `${baseUrl}/favorites/search/{{offset}}/{{limit}}`,
  addFavoriteUser: `${baseUrl}/favorites/{{userUuid}}`,
  removeFavoriteUser: `${baseUrl}/favorites/{{userUuid}}`,
  callUser: `${baseUrl}/sippy/webcall/{{userUuid}}`,
  startAiVoiceCall: `${baseUrl2}/ai-voice-calls/start`,
  getSettings: `${baseUrl}/settings`,
  updateSettings: `${baseUrl}/settings`,
  notifications: `${baseUrl}/notifications/{{offset}}/{{limit}}`,
  unReadNotificationsCount: `${baseUrl}/notifications/notread`,
  markAllNotificationsAsRead: `${baseUrl}/notifications`,
  markOneNotificationAsRead: `${baseUrl}/notifications/{{notificationUuid}}`,
  updateSearchCriteria: `${baseUrl}/searchcriterias`,
  removeAccount: `${baseUrl}/accountdelete/{{reasonTypeId}}`,
  getReasons: `${baseUrl}/accountdelete/reason-types`,
  discoverList: `${baseUrl}/discover/list/{{offset}}/{{limit}}`,
  chatUserList: `${baseUrl}/chat/friends/{{offset}}/{{limit}}`,
  chatUserList2: `${baseUrl2}/chat/friends/{{offset}}/{{limit}}`,
  getChat: `${baseUrl}/chat/total-history/{{userUuid}}/{{offset}}/{{limit}}`,
  getChat2: `${baseUrl2}/chat/total-history/{{userUuid}}/{{offset}}/{{limit}}`,
  chatMarkSeen: `${baseUrl}/chat/markSeen`,
  chatMarkSeen2: `${baseUrl2}/chat/markSeen`,
  chatDeleteHistory: `${baseUrl2}/chat/deleteHistory`, // POST -> body { uuid: "userUuid" }
  chatUnlockAiImage: `${baseUrl2}/chat/ai-generated-image/unlock`,
  guulMatch: `${baseUrl2}/guul/match`, // POST -> body { opponentUserId, is_used_credits } | { opponentUserId, is_join }
  chatMediaRequest: `${baseUrl2}/chat/media-request`, // POST -> body { to_user_uuid, media_type }
  chatMediaRequestFulfill: `${baseUrl2}/chat/media-request/{{requestId}}/fulfill`, // POST multipart { file }
  chatMediaRequestUnlock: `${baseUrl2}/chat/media-request/{{requestId}}/unlock`, // POST -> no body
  chatCommunityUsers: `${baseUrl2}/chat-communities/users/{{offset}}/{{limit}}`,
  chatCommunityMoods: `${baseUrl2}/chat-communities/moods`,
  chatCommunityMyMood: `${baseUrl2}/chat-communities/mood`,
  accountCredits: `${baseUrl}/accounts/credits`,
  accountEarnedCredits: `${baseUrl}/accounts/earned-credits`,
  getGifts: `${baseUrl}/gift`,
  getSentGiftMedias: `${baseUrl}/gift/sent/multimedia/{{offset}}/{{limit}}`,
  getSentGifts: `${baseUrl}/gift/sent/{{offset}}/{{limit}}`,
  getSentGifts2: `${baseUrl}/gift/sent-v1/{{offset}}/{{limit}}`,
  getReceivedGifts: `${baseUrl}/gift/received/{{offset}}/{{limit}}`,
  getReceivedGifts2: `${baseUrl}/gift/received-v1/{{offset}}/{{limit}}`,
  getReceivedGiftMedias: `${baseUrl}/gift/received/multimedia/{{offset}}/{{limit}}`,
  getMultimediaCredits: `${baseUrl}/gift/multimedia`,
  updateOnlineStatus: `${baseUrl}/userprofiles/onlineStatus/{{status}}`,
  getLandingProducts: `${baseUrl}/product/landing-products`,
  getProducts: `${baseUrl}/product?lang=tr`,
  getChatProducts: `${baseUrl}/chat/products?lang=tr`,
  buyChatProduct: `${baseUrl}/chat/buyProduct`,
  updateCallType: `${baseUrl}/userprofiles/callType/{{type}}`,
  getBlockedUsers: `${baseUrl}/blocks/search/{{offset}}/{{limit}}`,
  getReverseFavorites: `${baseUrl}/favorites/searchby/{{offset}}/{{limit}}`,
  getCalls: `${baseUrl}/accounts/history/{{offset}}/{{limit}}`,
  getCallHistory: `${baseUrl}/accounts/call-history/{{offset}}/{{limit}}`,
  sendGift: `${baseUrl}/gift/send`,
  getMedias: `${baseUrl2}/multimedia/user/{{ownId}}`, // GET
  getImages: `${baseUrl2}/multimedia/images/user/{{ownId}}`, // GET
  getVideos: `${baseUrl}/multimedia/videos/user/{{ownId}}`, // GET
  uploadImage: `${baseUrl2}/multimedia/images`, // POST
  uploadVideo: `${baseUrl}/multimedia/videos`, // POST
  uploadBondingVideo: `${baseUrl2}/user_bondings`, // POST multipart { file, type: bonding }
  removeImage: `${baseUrl2}/multimedia/images/{{imageId}}`, // DELETE
  removeVideo: `${baseUrl}/multimedia/videos/{{videoId}}`, // DELETE
  toggleImageStatus: `${baseUrl}/multimedia/toggleStatus/{{imageId}}`, // PUT
  setUserProfileImage: `${baseUrl}/userprofiles/profileImage/{{imageId}}`, // PUT
  paymentPostnetInit: `${baseUrl}/payments/posnet/init`, // POST
  paymentPostnetPerform: `${baseUrl}/payments/posnet/perform`, // POST
  paymentCraftgateInit: `${baseUrl}/cgprovider/init`, // POST
  paymentCraftgateFinalize: `${baseUrl}/cgprovider/finalize`, // POST
  blockUser: `${baseUrl}/blocks/{{userUuid}}`, // POST
  unBlockUser: `${baseUrl}/blocks/{{userUuid}}`, // DELETE
  reportUser: `${baseUrl}/support/report`, // POST
  support: `${baseUrl}/support`, // POST
  loginGoogle: `${baseUrl}/users/google-login`, // POST
  loginFacebook: `${baseUrl}/users/fb-login`, // POST
  loginApple: `${baseUrl}/users/apple-login`, // POST
  getCashouts: `${baseUrl}/payments/cashouts`, // GET
  postCashout: `${baseUrl}/payments/cashout`, // POST
  postSupportCashout: `${baseUrl}/support/cashout`, // POST
  postPaymentsCashout: `${baseUrl}/payments/cashout-request`, // POST
  postPaymentsUserCashoutDetails: `${baseUrl}/payments/user-cashout-details`, // POST
  paybymePurchase: `${baseUrl}/paybyme/purchase`, // POST
  phoneNumberUpdate: `${baseUrl}/users/phonenumber`, // PUT {"phoneNumber":"05321111111"}
  phoneNumberVerification: `${baseUrl}/users/phonenumber-verification`, // PUT {"phoneNumber":"05321111111", "pinCode":"1234"}
  emailUpdate: `${baseUrl}/users/email-update`, // PUT {"email": "email@email.com"}
  emailUpdateVerification: `${baseUrl}/users/email-update-verification`, // PUT {"email": "email@email.com", "pinCode":"1234"}
  updateLanguage: `${baseUrl}/userprofiles/lang/{{lang}}`,
  appCall: `${baseUrl}/app/call/{{userUuid}}`, // POST
  appVideoCall: `${baseUrl}/app/video-call/{{userUuid}}`, // POST
  appSwitchCallType: `${baseUrl}/app/switch-call-type`, // POST
  appCallCancel: `${baseUrl}/app/cancel`, // POST
  heartBeat: `${baseUrl}/app/heartbeat`, // POST
  updateCameraStatus: `${baseUrl}/userprofiles/camera-on/{{status}}`, // POST
  creditsCharged: `${baseUrl}/app/credits-charged`, // GET
  campaigns: `${baseUrl}/campaigns`, // GET
  campaigns2: `${baseUrl}/campaigns/2`, // GET
  campaignsDisplayed: `${baseUrl}/campaigns/displayed`, // POST
  couponCodeToAddDiamond: `${baseUrl}/payments/coupon-code`, // POST { "code": "xyz" }
  couponCodeCheckBeforePurchasing: `${baseUrl}/payments/check-coupon-code`, // POST { "code": "xyz" }
  checkOneTimeOffer: `${baseUrl}/payments/check-onetime-offer`, // POST { "productId": "string", "campaignId": "string"}
  checkBonusCredits: `${baseUrl}/payments/check-bonus`, // POST { "productId": "string", "campaignId": "string"}
  lpUserAction: `${baseUrl}/users/landing-page-action`, // POST {"flow": "string", "action": "string", "data": "string"}
  getListTypes: `${baseUrl}/users/boho-club/list-types`,
  bohoClubListTypes: `${baseUrl}/users/boho-club/list-types`, // GET
  bohoClubPublishers: `${baseUrl}/stream/boho-club-publishers`, // GET
  userInformationSha256: `${baseUrl}/users/sha256`, // GET

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',

  // v2 API
  checkNudity: `${baseUrl2}/check-nudity`,

  // v2 Posts
  newPost: `${baseUrl2}/posts`, // POST -> formData { content: '', file: file }
  posts: `${baseUrl2}/posts/{{offset}}/{{limit}}`, // GET
  postsForYou: `${baseUrl2}/posts/for-you/{{offset}}/{{limit}}`, // GET
  postsDiscovery: `${baseUrl2}/posts/discovery/{{offset}}/{{limit}}`, // GET
  postsDiscoveryOpen: `${baseUrl2}/posts/discovery/open`, // GET
  userPosts: `${baseUrl2}/posts/user/{{uuid}}/{{offset}}/{{limit}}`, // GET
  deletePost: `${baseUrl2}/posts/{{id}}`, // DELETE
  managePost: `${baseUrl2}/posts/manage`, // POST -> body { post_id: 1, status: 0 }
  likePost: `${baseUrl2}/posts/like`, // POST -> body { post_id: 1 }
  likePostDelete: `${baseUrl2}/posts/like/{{id}}`, // DELETE

  // v2 Missions
  missions: `${baseUrl2}/missions/{{url}}?date={{date}}`, // GET
  missionsActive: `${baseUrl2}/missions/active-missions`, // GET
  missionsCollectedBeans: `${baseUrl2}/missions/collected-beans?date={{date}}`, // GET
  missionsConnectedTime: `${baseUrl2}/missions/connected-time?date={{date}}`, // GET
  missionsMomentMessageTime: `${baseUrl2}/missions/moments-message-count?date={{date}}`, // GET
  missionsCallCount: `${baseUrl2}/missions/call-count?date={{date}}`, // GET
  missionsNdc: `${baseUrl2}/missions/ndc?date={{date}}`, // GET
  missionsProfilePhotoTask: `${baseUrl2}/missions/profil-photo-tasks`, // GET
  incentiveDailyNewTask: `${baseUrl2}/missions/new-daily-tasks?date={{date}}`, // GET
  newDailyTasksEligibleList: `${baseUrl2}/new-daily-tasks/eligible-new-daily-task-list`, // GET
  referralMe: `${baseUrl2}/referrals/me`,
  referralInvitees: `${baseUrl2}/referrals/invitees`,
  referralClaim: `${baseUrl2}/referrals/claim`,
  newDailyTasks: `${baseUrl2}/new-daily-tasks/list?type={{type}}`, // GET
  newDailyTasksList: `${baseUrl2}/new-daily-tasks/list?type={{type}}&offset={{offset}}&limit={{limit}}`, // GET - kullanıcı listesi için sayfalama
  newDailyTasksPendingChatList: `${baseUrl2}/new-daily-tasks/pending-chat-list?offset={{offset}}&limit={{limit}}`, // GET - cevap bekleyen kullanıcılar
  newDailyTasksProcessUsers: `${baseUrl2}/new-daily-tasks/process-users`, // GET

  // v2 Face Detection
  faceDetection: `${baseUrl2}/face-detection`, // POST formData { mi, image: me-type: '', image: base64 }
  faceDetect: `${baseUrl2}/face-detect`, // POST { call_id: 2, detect: false | true }

  // v2 Report
  reportUser2: `${baseUrl2}/complaints`, // POST

  // v2 PWA Setup
  checkPwaFirstSetup: `${baseUrl2}/virtual-credit/check-pwa-first-setup`, // GET
  pwaFirstSetup: `${baseUrl2}/virtual-credit/pwa-first-setup`, // GET

  // Female host applications
  postFemaleHostApplications: `${baseUrl2}/female-host-applications`, // POST {user_id: id}

  // Bonus campaign
  bonusCampaignCheck: `${baseUrl2}/bonus-campaign/check`,
  bonusCampaignUserList: `${baseUrl2}/bonus-campaign/user-list?offset={{offset}}&limit={{limit}}`,

  // Outcall kampanyası
  bonusOutcallCheck: `${baseUrl2}/missions/outcall-active-control`,
  bonusOutcallUsers: `${baseUrl2}/missions/outcall-bonus-users?offset={{offset}}&limit={{limit}}`,

  // Trigger campaigns
  userTriggeredFreeMessage: `${baseUrl2}/user-triggered-free-message`,

  // V2
  checkinPopupData: `${baseUrl2}/checkin-popup-data`,
  checkinPopupDataConfirm: `${baseUrl2}/checkin-popup-data/confirm`, // {id: 1234}

  // Special Contents
  specialContentsAvailability: `${baseUrl2}/webview/special-contents/availability`, // GET
  specialContents: `${baseUrl2}/webview/special-contents?offset={{offset}}&limit={{limit}}`, // GET
  specialContentCreate: `${baseUrl2}/webview/special-contents`, // POST multipart { file, content? }
  specialContentDelete: `${baseUrl2}/webview/special-contents/{{id}}`, // DELETE

  // Voice Rooms
  getVoiceRoomGifts: `${baseUrl}/voice-room/gifts`,
  publishVoiceRoom: `${baseUrl}/voice-room/publish`,
  sendVoiceRoomGift: `${baseUrl}/voice-room/gift`,
  sendVoiceRoomHeartbeat: `${baseUrl}/voice-room/heartbeat`,
  endVoiceRoom: `${baseUrl}/voice-room/end-publish`,
  subscribeVoiceRoom: `${baseUrl}/voice-room/subscribe/{{channelId}}`,
  getVoiceRoomPublishers: `${baseUrl}/voice-room/publisher-list/{{channelId}}`,
  sendVoiceRoomBePublisher: `${baseUrl}/voice-room/be-publisher`,
  approveSpeakerRequest: `${baseUrl}/voice-room/approve-publisher/{{uuid}}`,
  rejectSpeakerRequest: `${baseUrl}/voice-room/reject-publisher/{{uuid}}`,
  getListOfVoiceRoomParticipants: `${baseUrl}/voice-room/attendee-list/{{channelId}}`,
  getGoalsOfVoiceRoom: `${baseUrl}/voice-room/goals/{{channelId}}`,
  kickUserFromVoiceRoom: `${baseUrl}/voice-room/kick-user/{{uuid}}`,
  toggleMuteVoiceRoom: `${baseUrl}/voice-room/toggle-voice/{{channelId}}/{{uuid}}`,
  getReceivedGiftsVoiceRoom: `${baseUrl}/voice-room/received-gift-list/{{channelId}}`,

  // Video Rooms
  getVideoRoomGifts: `${baseUrl}/stream/gifts`,
  publishVideoRoom: `${baseUrl}/stream/publish`,
  sendVideoRoomGift: `${baseUrl}/stream/gift`,
  sendVideoRoomHeartbeat: `${baseUrl}/stream/heartbeat`,
  endVideoRoom: `${baseUrl}/stream/end-publish`,
  subscribeVideoRoom: `${baseUrl}/stream/subscribe/{{channelId}}/{{publisherId}}`,
  getVideoRoomPublishers: `${baseUrl}/stream/publisher-list`,
  sendVideoRoomBePublisher: `${baseUrl}/stream/be-publisher`,
  approveSpeakerRequestVideoRoom: `${baseUrl}/stream/approve-publisher/{{uuid}}`,
  rejectSpeakerRequestVideoRoom: `${baseUrl}/stream/reject-publisher/{{uuid}}`,
  getListOfVideoRoomParticipants: `${baseUrl}/stream/subscribers/{{channelId}}/{{publisherId}}`,
  getGoalsOfVideoRoom: `${baseUrl}/stream/goals/{{channelId}}`,
  kickUserFromVideoRoom: `${baseUrl}/stream/kick-user/{{uuid}}`,
  toggleMuteVideoRoom: `${baseUrl}/stream/toggle-voice/{{channelId}}/{{uuid}}`,
  getReceivedGiftsVideoRoom: `${baseUrl}/stream/received-gift-list/{{channelId}}/{{publisherId}}`,

  // Male User Tasks
  maleUserTasksWeeklyStatus: `${baseUrl2}/male-user-tasks/weekly-status`, // GET ?test_date=2025-12-29
  maleUserTasksCheckIn: `${baseUrl2}/male-user-tasks/check-in`, // POST
  maleUserTasksConvertWeekly: `${baseUrl2}/male-user-tasks/convert-weekly`, // POST ?test_date=2025-12-29
}
